import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { CheckCircleIcon } from 'lucide-react';
const benefits = ['Entender exactamente por dónde empezar', 'Evitar perder tiempo probando cosas sin sentido', 'Tener un camino claro desde el primer día', 'Ver cómo otras personas ya lo están haciendo'];
export function SolutionSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="py-24 px-6 bg-dark-secondary" data-id="element-130">
      <div className="max-w-4xl mx-auto" data-id="element-131">
        <motion.h2 initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} className="text-3xl md:text-5xl font-serif font-bold text-text-primary mb-12 text-center" data-id="element-132">
          Con esta guía vas a:
        </motion.h2>

        <div className="max-w-2xl mx-auto space-y-5" data-id="element-133">
          {benefits.map((benefit, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -30
        }} animate={isInView ? {
          opacity: 1,
          x: 0
        } : {}} transition={{
          duration: 0.6,
          delay: 0.15 + index * 0.1
        }} className="flex items-start gap-4 p-5 bg-dark-bg/50 rounded-lg border border-dark-tertiary" data-id="element-134">
              <CheckCircleIcon className="w-6 h-6 text-accent flex-shrink-0 mt-0.5" data-id="element-135" />
              <p className="text-lg text-text-primary" data-id="element-136">{benefit}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}